module.exports = __webpack_public_path__ + "static/img/bg.8d72d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/bg.png
// module id = RBA5
// module chunks = 2